// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/BANNER-ICONTransfer-B.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General */
body {
	font-family: 'Montserrat', sans-serif;
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

.section {
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-size: cover;
	background-position: center;
	background-attachment: fixed;
}

.section .section-center {
	width: 100%;
	max-width: 1200px;
	position: relative;
	z-index: 1;
}

#booking::before {
	content: '';
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
	background: rgba(47, 103, 177, 0.6);
	z-index: 0;
}

/* Formulario */
.booking-form {
	position: relative;
	background-color: #fff;
	padding: 50px 30px;
	border-radius: 8px;
	box-shadow: 0px 5px 20px -5px rgba(0, 0, 0, 0.3);
	z-index: 1;
}

.booking-form .form-group {
	position: relative;
	margin-bottom: 30px;
}

.booking-form .form-control {
	background-color: transparent;
	border: none;
	border-bottom: 2px solid #000;
	border-radius: 0;
	height: 40px;
	box-shadow: none;
	color: #333;
	font-size: 14px;
	padding: 0 15px;
}

.booking-form .form-control:focus {
	border-bottom: 2px solid #1e62d8;
	outline: none;
}

.booking-form .form-control::placeholder {
	color: rgba(62, 72, 92, 0.6);
}

.booking-form .form-label {
	display: inline-block;
	color: #000;
	font-weight: 700;
	margin-bottom: 6px;
}

.booking-form .submit-btn {
	display: inline-block;
	width: 100%;
	color: #fff;
	background-color: #1e62d8;
	font-weight: 700;
	padding: 14px 30px;
	border-radius: 4px;
	border: none;
	transition: 0.2s all;
	z-index: 10;
	position: relative;
	text-align: center;
}

.booking-form .submit-btn:hover,
.booking-form .submit-btn:focus {
	background-color: #165bb7;
	cursor: pointer;
}

.booking-cta {
	margin-top: 80px;
	margin-bottom: 30px;
	color: #fff;
	z-index: 1;
}

.booking-cta h1 {
	font-size: 52px;
	text-transform: uppercase;
	color: #ffffff;
	font-weight: 700;
}

.booking-cta p {
	font-size: 16px;
	color: #ffffff;
}

/* Media Queries para Responsividad */
@media (max-width: 768px) {
	.section {
		height: auto;
		padding: 40px 0;
	}

	.booking-form {
		padding: 30px 20px;
	}

	.booking-cta h1 {
		font-size: 32px;
	}

	.booking-cta p {
		font-size: 14px;
	}

	.booking-form .submit-btn {
		font-size: 16px;
		padding: 12px 20px;
		width: 100%;
	}
}

/* Estilos adicionales para elementos interactivos */
.dropzone {
	border: 2px dashed #007bff;
	border-radius: 5px;
	padding: 20px;
	text-align: center;
	cursor: pointer;
	background-color: #f9f9f9;
	transition: background-color 0.3s ease;
}

.dropzone:hover {
	background-color: #e9ecef;
}

.click-link {
	color: blue;
	text-decoration: underline;
	cursor: pointer;
}

.react-logo {
	position: fixed;
	top: 5px;
	left: 0px;
	width: 100px;
}

@media (max-width: 768px) {
	.react-logo {
		width: 80px;
	}
}

.custom-modal-width {
	max-width: 800px;
	/* Ancho máximo */
	width: 100%;
	/* Ancho relativo a la pantalla */
}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;CACC,qCAAqC;CACrC,SAAS;CACT,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,yDAAyD;CACzD,sBAAsB;CACtB,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,SAAS;CACT,MAAM;CACN,mCAAmC;CACnC,UAAU;AACX;;AAEA,eAAe;AACf;CACC,kBAAkB;CAClB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB,gDAAgD;CAChD,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;CAC7B,YAAY;CACZ,6BAA6B;CAC7B,gBAAgB;CAChB,YAAY;CACZ,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,gCAAgC;CAChC,aAAa;AACd;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,WAAW;CACX,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CACZ,oBAAoB;CACpB,WAAW;CACX,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;;CAEC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,WAAW;CACX,UAAU;AACX;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA,qCAAqC;AACrC;CACC;EACC,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,WAAW;CACZ;AACD;;AAEA,oDAAoD;AACpD;CACC,0BAA0B;CAC1B,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CACzB,sCAAsC;AACvC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,QAAQ;CACR,SAAS;CACT,YAAY;AACb;;AAEA;CACC;EACC,WAAW;CACZ;AACD;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,WAAW;CACX,iCAAiC;AAClC","sourcesContent":["/* General */\nbody {\n\tfont-family: 'Montserrat', sans-serif;\n\tmargin: 0;\n\tpadding: 0;\n\tbox-sizing: border-box;\n}\n\n.section {\n\theight: 100vh;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-image: url('../img/BANNER-ICONTransfer-B.jpg');\n\tbackground-size: cover;\n\tbackground-position: center;\n\tbackground-attachment: fixed;\n}\n\n.section .section-center {\n\twidth: 100%;\n\tmax-width: 1200px;\n\tposition: relative;\n\tz-index: 1;\n}\n\n#booking::before {\n\tcontent: '';\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\ttop: 0;\n\tbackground: rgba(47, 103, 177, 0.6);\n\tz-index: 0;\n}\n\n/* Formulario */\n.booking-form {\n\tposition: relative;\n\tbackground-color: #fff;\n\tpadding: 50px 30px;\n\tborder-radius: 8px;\n\tbox-shadow: 0px 5px 20px -5px rgba(0, 0, 0, 0.3);\n\tz-index: 1;\n}\n\n.booking-form .form-group {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.booking-form .form-control {\n\tbackground-color: transparent;\n\tborder: none;\n\tborder-bottom: 2px solid #000;\n\tborder-radius: 0;\n\theight: 40px;\n\tbox-shadow: none;\n\tcolor: #333;\n\tfont-size: 14px;\n\tpadding: 0 15px;\n}\n\n.booking-form .form-control:focus {\n\tborder-bottom: 2px solid #1e62d8;\n\toutline: none;\n}\n\n.booking-form .form-control::placeholder {\n\tcolor: rgba(62, 72, 92, 0.6);\n}\n\n.booking-form .form-label {\n\tdisplay: inline-block;\n\tcolor: #000;\n\tfont-weight: 700;\n\tmargin-bottom: 6px;\n}\n\n.booking-form .submit-btn {\n\tdisplay: inline-block;\n\twidth: 100%;\n\tcolor: #fff;\n\tbackground-color: #1e62d8;\n\tfont-weight: 700;\n\tpadding: 14px 30px;\n\tborder-radius: 4px;\n\tborder: none;\n\ttransition: 0.2s all;\n\tz-index: 10;\n\tposition: relative;\n\ttext-align: center;\n}\n\n.booking-form .submit-btn:hover,\n.booking-form .submit-btn:focus {\n\tbackground-color: #165bb7;\n\tcursor: pointer;\n}\n\n.booking-cta {\n\tmargin-top: 80px;\n\tmargin-bottom: 30px;\n\tcolor: #fff;\n\tz-index: 1;\n}\n\n.booking-cta h1 {\n\tfont-size: 52px;\n\ttext-transform: uppercase;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n}\n\n.booking-cta p {\n\tfont-size: 16px;\n\tcolor: #ffffff;\n}\n\n/* Media Queries para Responsividad */\n@media (max-width: 768px) {\n\t.section {\n\t\theight: auto;\n\t\tpadding: 40px 0;\n\t}\n\n\t.booking-form {\n\t\tpadding: 30px 20px;\n\t}\n\n\t.booking-cta h1 {\n\t\tfont-size: 32px;\n\t}\n\n\t.booking-cta p {\n\t\tfont-size: 14px;\n\t}\n\n\t.booking-form .submit-btn {\n\t\tfont-size: 16px;\n\t\tpadding: 12px 20px;\n\t\twidth: 100%;\n\t}\n}\n\n/* Estilos adicionales para elementos interactivos */\n.dropzone {\n\tborder: 2px dashed #007bff;\n\tborder-radius: 5px;\n\tpadding: 20px;\n\ttext-align: center;\n\tcursor: pointer;\n\tbackground-color: #f9f9f9;\n\ttransition: background-color 0.3s ease;\n}\n\n.dropzone:hover {\n\tbackground-color: #e9ecef;\n}\n\n.click-link {\n\tcolor: blue;\n\ttext-decoration: underline;\n\tcursor: pointer;\n}\n\n.react-logo {\n\tposition: fixed;\n\ttop: 5px;\n\tleft: 0px;\n\twidth: 100px;\n}\n\n@media (max-width: 768px) {\n\t.react-logo {\n\t\twidth: 80px;\n\t}\n}\n\n.custom-modal-width {\n\tmax-width: 800px;\n\t/* Ancho máximo */\n\twidth: 100%;\n\t/* Ancho relativo a la pantalla */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
